import { combineReducers } from "redux";
import itemsReducer from "./itemsReducer";
import orderedItemsReducer from "./orderedItemsReducer";
import permissionsReducer from "./permissionsReducer";
import scheduleItemsReducer from "./scheduleItemsReducer";

export default combineReducers({
  items: itemsReducer,
  orderedItems: orderedItemsReducer,
  permissions: permissionsReducer,
  scheduleItems: scheduleItemsReducer,
});
